export const apiFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };

  const response = await fetch(`https://s-backend-rebuild-production.up.railway.app${endpoint}`, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {})
    }
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'API request failed');
  }

  return response.json();
};

export const getAllCars = async () => {
  try {
    const apiUrl = 'https://s-backend-rebuild-production.up.railway.app/api/cars';

    const response = await fetch(apiUrl);
    
    if (!response.ok) {
      const errorMessage = `Error ${response.status}: ${response.statusText}`;
      throw new Error(errorMessage);
    }

    const text = await response.text();

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      if (text.trim() === '') {
        return []; 
      }
      try {
        return JSON.parse(text);
      } catch (jsonError) {
        throw new Error('Failed to parse JSON response');
      }
    } else {
      throw new Error('Response is not JSON');
    }
  } catch (error) {
    throw error;
  }
};